const reducers = (state, action) => {
  switch (action.type) {
    case "getRepos": {
      return { ...state, loading: true, error: null };
    }
    case "updateRepos": {
      return {
        ...state,
        projects: Array.isArray(action.item) ? action.item : [],
        loading: false,
      };
    }
    case "reposError": {
      return { ...state, loading: false, error: action.error || "Unable to load repositories." };
    }
    default: {
      return state;
    }
  }
};

export default reducers;
